import {
  useGoogleLogin,
  GoogleOAuthProvider,
  GoogleLogin,
} from '@react-oauth/google';
import { connect, useDispatch, useSelector } from 'react-redux';
import { css } from '@emotion/react';
import { blocks } from '@birdi/theme'
import { BirdiTheme } from '@birdi/theme';
// @ts-ignore - JS file without types
import { signInWithGoogleToken } from '../actions';
// @ts-ignore - JS file without types
import { useAuthSelector } from '../reducer';
import GoogleLogoSVG from '../../icons/google-logo.svg';
// @ts-ignore - JS file without types
import { useMetaSelector } from '../../meta/reducer';

interface GoogleAuthButtonProps {
  label: string;
}

// useGoogleLogin({
//   onSuccess: (credentialResponse) => {
//     console.log('credentialResponse: ', credentialResponse);
//     // _signInWithGoogleToken();
//   },
// });

const GoogleButtonInternal: React.FC<GoogleAuthButtonProps> = ({ label }) => {
  const dispatch = useDispatch();
  const login = useGoogleLogin({
    flow: 'auth-code',
    onSuccess: (response) => {
      signInWithGoogleToken(dispatch)(response.code);
    },
  });
  return (
    <button
      type="button"
      onClick={() => {
        login();
      }}
      css={(theme: BirdiTheme) => css`
        width: 100%;
        padding: 0.75rem 1.25rem;
        background-color: ${theme.mono0};
        color: ${theme.mono70};
        border: 1px solid ${theme.mono30};
        border-radius: 0.5rem;
        font-size: 0.9375rem;
        font-weight: 500;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;
        transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
        box-shadow: none;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 2px 2px 4px ${theme.mono30};
          border-color: ${theme.mono40};
        }

        &:active {
          transform: scale(0.98);
        }
      `}
    >
      <div
        css={css`
          width: 1.25rem;
          height: 1.25rem;
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <GoogleLogoSVG />
      </div>
      <span>{label || 'Sign in with Google'}</span>
    </button>
  );
};

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({
  label,
}) => {
  const meta = useMetaSelector();
  if (meta.loaded) return null;

  const clientId = process.env.GOOGLE_CLIENT_ID;
  if (!clientId) return null;

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <GoogleButtonInternal label={label} />
    </GoogleOAuthProvider>
  );

  // return (
  //   <GoogleOAuthProvider clientId={process.env.GOOGLE_CLIENT_ID}>
  //     <GoogleLogin
  //       onSuccess={(credentialResponse) => {
  //         console.log('credentialResponse: ', credentialResponse);
  //         // signInWithGoogleToken(dispatch);
  //       }}
  //       onError={() => console.log('Login Failed')}
  //       text={label ? 'signup_with' : 'signin_with'}
  //       size="large"
  //       theme="outline"
  //       logo_alignment="center"
  //       width="600px"
  //       style={{ textAlign: 'center' }}
  //     />
  //   </GoogleOAuthProvider>
  // );
};
